module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.cdb58b39.svg";